import React, { useEffect } from 'react';
import Hero from '../../components/sections/Hero';
import Overview from '../../components/sections/Overview';
import Services from '../../components/sections/Services';
import Process from '../../components/sections/Process';
import Technologies from '../../components/sections/Technologies';
import Gallery from '../../components/sections/Gallery';
import Cta from '../../components/sections/Cta';
import { setupScrollAnimations } from '../../utils/animations';
import { mlPageData } from '../../data/mlPageData';

const MlPage = () => {
  useEffect(() => {
    const observer = setupScrollAnimations();
    return () => observer.disconnect();
  }, []); 

  return (
    <div>
      <Hero
        variant="biHero"
        title={mlPageData.hero.title}
        description={mlPageData.hero.description}
      />
      <Overview data={mlPageData.overview} />
      <Services data={mlPageData.services} />
      <Process data={mlPageData.process} />
      <Technologies data={mlPageData.technologies} />
      <Gallery data={mlPageData.gallery} />
      <Cta data={mlPageData.cta} />
    </div>
  );
};

export default MlPage;


